<template>
  <el-tree
    ref="tree"     
    class="AProductTypeTreeSelector"     
    default-expand-all
    :data="data"
    :props="props"
    :indent="10"
    @current-change="handleChange"
    >
  </el-tree>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AProductTypeTreeSelector",
  data() {
    return {
      props: {
        children: 'children',
        label: 'name',
      },
    }    
  },
  computed: {
    ...mapGetters(["table_product_type"]),
    data: function() {     
      let items =  this.system.organizeProductType(this.table_product_type);
      items.splice(0, 0, {id: 0, name: '전체보기'});
      return items;
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('select', value.id);
    },
  },
};
</script>